import { event } from '../content/event';

const RSVP_ENDPOINT =
  'https://acr632a3lh.execute-api.us-east-1.amazonaws.com/bbabdt21_rsvp';

export async function submitRsvp(values) {
  const attending = values.attendanceStatus === 'attending';

  const response = await fetch(RSVP_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      eventYear: event.year,
      attendanceStatus: values.attendanceStatus,
      email: values.email.trim(),
      name: values.name.trim(),
      partySize: attending ? Number(values.partySize) : 0,
      dish: attending ? values.dish.trim() : '',
      dietaryAccessibility: values.dietaryAccessibility.trim(),
      message: values.message.trim(),
      website: values.website,
    }),
  });

  let result = {};
  try {
    result = await response.json();
  } catch (_error) {
    // A non-JSON response is reported as a generic failure below.
  }
  if (!response.ok) throw new Error(result.message || 'Unable to process RSVP');
  return result;
}
